import { useSelector } from 'react-redux'

export const useAuthentication = () => {
    return useSelector(state => state.auth || { isAuthenticated : false });
}

